(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ReportService', ReportService);

    ReportService.$inject = ['$resource'];

    function ReportService($resource) {
        var getSalesCountReportOfCurrentCompany = function () {
            var resourceUrl = 'api/getSalesCountReportOfCurrentCompany';
            return $resource(resourceUrl);
        }

        return {

            getSalesCountReportOfCurrentCompany: getSalesCountReportOfCurrentCompany
        };


    }
})();
